import { combineReducers } from "redux";

// ? Reducers
import gamesReducer from "./gameReducer";
import detailReducer from "./detailReducer";

const rootReducer = combineReducers({
  games: gamesReducer,
  gameDetail: detailReducer,
});

export default rootReducer;
